module.exports = __webpack_public_path__ + "static/media/unselected.04e497d3.svg";